import { render, staticRenderFns } from "./baisc-info.vue?vue&type=template&id=fbd4e63e&scoped=true"
import script from "./baisc-info.vue?vue&type=script&lang=js"
export * from "./baisc-info.vue?vue&type=script&lang=js"
import style0 from "./baisc-info.vue?vue&type=style&index=0&id=fbd4e63e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbd4e63e",
  null
  
)

export default component.exports